import React, { useContext } from "react";
import PropTypes from "prop-types";
import { Grid, Typography } from "@mui/material";
import withStyles from "@mui/styles/withStyles";
import { UserContext } from "../../UserContext";

const styles = (props) => ({
  padding: {
    padding: 10,
  },
  underline: {
    textDecoration: "underline",
  },
  spacing: {
    fontSize: 16,
    cursor: "pointer",
    fontWeight: "bold",
    color: "black",
  },
});
const Footer = (props) => {
  const { classes } = props;
  const { canViewComments, businessInfo, userInfo } = useContext(UserContext);
  const { permissions } = userInfo;
  const { hasBusinessLocations } = businessInfo;

  if (hasBusinessLocations && permissions?.length) {
    const { businessLocationPermissions } = permissions[0];
    if (businessLocationPermissions?.length === 1) {
      const { businessLocation } = businessLocationPermissions[0];
      const { webPage, name } = businessLocation;
      businessInfo.webPage = webPage;
      businessInfo.name = name;
    }
  }

  if (
    canViewComments ||
    (!businessInfo?.name?.length && !businessInfo?.webPage?.length)
  ) {
    return <></>;
  }

  return (
    <Grid
      container
      justifyContent="space-between"
      alignItems="center"
      className={classes.padding}
    >
      <Grid item>
        {businessInfo?.name?.length > 0 && (
          <Typography variant="subtitle1">{businessInfo?.name}</Typography>
        )}

        {businessInfo?.webPage?.length > 0 && (
          <Typography variant="subtitle1" className={classes.spacing}>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={`https://${businessInfo?.webPage}`}
              className={[classes.underline, classes.spacing].join(" ")}
            >
              {businessInfo?.webPage}
            </a>
          </Typography>
        )}
      </Grid>
    </Grid>
  );
};

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Footer);
